import { Skeleton } from "components/ui/legacy/Skeleton";
import { lazy, Suspense } from "react";

import { TeamsAuthWall } from "../teamsAuthWall";

const NewTicketPage = lazy(() =>
  import("components/pages/NewTicketPage/NewTicketPage").then((module) => ({ default: module.NewTicketPage })),
);

export const TeamsNewTicketPage = () => (
  <TeamsAuthWall>
    <Suspense fallback={<Skeleton height="100%" width="100%" />}>
      <NewTicketPage />
    </Suspense>
  </TeamsAuthWall>
);
